import React from 'react';
import {Icon} from 'antd';

import InstructionLayout, {
    InstructionSpotlight,
    InstructionStep
} from '../instruction-layout';


const submitBidItems = [
    {
        id: 'submit-bid',
        number: 1,
        content: (
            <>
                Нажмите кнопку
                <strong> «Подать заявку»</strong>.
            </>
        ),
        area: {
            top: 70.81,
            left: 78.21,
            width: 18.28,
            height: 21.23
        }
    }
];


const registrationItems = [
    {
        id: 'registry-extract',
        number: 1,
        content: (
            <>
                Если выписка уже получена, выберите
                <strong> «Выписка из реестра»</strong>,
                укажите её номер и прикрепите файл.
            </>
        ),
        area: {
            top: 48,
            left: 6.36,
            width: 16.23,
            height: 3.93
        }
    },
    {
        id: 'registry-application',
        number: 2,
        content: (
            <>
                Если выписки ещё нет, выберите
                <strong> «Заявление о регистрации в реестре» </strong>
                и прикрепите только заявление.
            </>
        ),
        area: {
            top: 48,
            left: 22.7,
            width: 27,
            height: 3.93
        }
    },
    {
        id: 'save',
        number: 3,
        content: (
            <>
                Нажмите кнопку
                <strong> «Сохранить»</strong>.
            </>
        ),
        area: {
            top: 88.16,
            left: 41.77,
            width: 16.69,
            height: 5.36
        }
    }
];


const applicationStatusItems = [
    {
        id: 'cabinet',
        number: 1,
        content: (
            <>
                Перейдите в раздел
                <strong> «Кабинет»</strong>.
            </>
        ),
        area: {
            top: 1.31,
            left: 34.28,
            width: 6.02,
            height: 4.9
        }
    },
    {
        id: 'applications',
        number: 2,
        content: (
            <>
                Откройте раздел
                <strong> «Заявки»</strong>.
            </>
        ),
        area: {
            top: 45.37,
            left: 3.18,
            width: 21.68,
            height: 5.55
        }
    },
    {
        id: 'goslog-applications',
        number: 3,
        content: (
            <>
                Выберите вкладку
                <strong> «Заявки ГосЛог»</strong>.
            </>
        ),
        area: {
            top: 60.9,
            left: 3.18,
            width: 21.68,
            height: 5.55
        }
    },
    {
        id: 'application-status',
        number: 4,
        content: (
            <>
                Проверьте статус заявки в таблице.
            </>
        ),
        area: {
            top: 41.32,
            left: 62.43,
            width: 10.67,
            height: 4.68
        }
    }
];


export default function GosLogVitalApprovalInstruction() {
    return (
        <InstructionLayout
            title={'Согласование ГосЛог у "Витал"'}
        >
            <p className="instruction-intro">
                Для подачи ставки на рейс ГК «Витал»
                экспедитору необходимо подтвердить статус
                регистрации в ГосЛог.
            </p>

            <div className="service-highlight">
                <span className="service-highlight__icon">
                    <Icon type="audit"/>
                </span>

                <div>
                    <strong className="service-highlight__title">
                        Подтверждение обязательно
                    </strong>

                    <p className="service-highlight__text">
                        Без загрузки подтверждающего документа
                        ставки экспедитора по рейсам ГК «Витал»
                        не будут отображаться.
                    </p>
                </div>
            </div>

            <InstructionStep
                number="1"
                title="Подайте ставку на рейс"
            >
                <div className="instruction-copy">
                    <p>
                        Откройте подходящий рейс и приступите
                        к подаче ставки.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/goslog-vital-approval/01-submit-bid.png"
                    alt="Кнопка подачи заявки на рейс"
                    items={submitBidItems}
                />
            </InstructionStep>

            <InstructionStep
                number="2"
                title="Подтвердите регистрацию в ГосЛог"
            >
                <div className="instruction-copy">
                    <p>
                        При попытке подать ставку платформа покажет
                        уведомление с требованием подтвердить статус
                        регистрации в ГосЛог. Выберите подходящий
                        вариант и загрузите необходимый документ.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/goslog-vital-approval/02-registration-confirmation.png"
                    alt="Подтверждение регистрации в ГосЛог"
                    items={registrationItems}
                    layout="grid"
                />

                <div className="service-note">
                    <Icon
                        className="service-note__icon"
                        type="info-circle"
                    />

                    <p className="service-note__text">
                        Заявление можно использовать, если выписка
                        ещё не получена. После регистрации выписку
                        всё равно потребуется загрузить.
                    </p>
                </div>
            </InstructionStep>

            <InstructionStep
                number="3"
                title="Проверьте статус заявки"
            >
                <div className="instruction-copy">
                    <p>
                        После отправки документ поступит на согласование
                        в ГК «Витал». Статус заявки можно проверить
                        в личном кабинете.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/goslog-vital-approval/03-application-status.png"
                    alt="Статус заявки на согласование ГосЛог"
                    items={applicationStatusItems}
                    layout="grid"
                />

                <div className="instruction-copy">
                    <p>
                        После завершения проверки уведомление
                        о результате согласования появится
                        в личном кабинете.
                    </p>
                </div>
            </InstructionStep>
        </InstructionLayout>
    );
}